export default {
  ISEVEN: 1,
  MODULUS: 2,
  PLATAFORMA_CLIENTE: 3,
  PLATAFORMA_CRM: 4
};
